/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { LlgResourcePolicy } from '../models/LlgResourcePolicy';
import { LogSourceLocation } from '../models/LogSourceLocation';

export class LogSourceWithPolicy {
  /**
  * Log source ID.
  */
  'id': string;
  /**
  * Log source display name.
  */
  'name'?: string;
  /**
  * Type of log source.
  */
  'type': LogSourceWithPolicyTypeEnum;
  'location': LogSourceLocation;
  'policy'?: LlgResourcePolicy | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "type",
      "baseName": "type",
      "type": "LogSourceWithPolicyTypeEnum",
      "format": ""
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "LogSourceLocation",
      "format": ""
    },
    {
      "name": "policy",
      "baseName": "policy",
      "type": "LlgResourcePolicy",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return LogSourceWithPolicy.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum LogSourceWithPolicyTypeEnum {
  Cloudtrail = 'CLOUDTRAIL',
  Datadog = 'DATADOG',
  Cloudwatch = 'CLOUDWATCH',
  Splunk = 'SPLUNK'
}

